function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.354 0.987631C13.4006 1.03627 13.4375 1.09405 13.4627 1.15766C13.4879 1.22128 13.5009 1.28947 13.5009 1.35835C13.5009 1.42722 13.4879 1.49542 13.4627 1.55903C13.4375 1.62264 13.4006 1.68042 13.354 1.72906L7.35402 8.01238C7.30758 8.06114 7.2524 8.09983 7.19166 8.12622C7.13091 8.15262 7.06579 8.16621 7.00002 8.16621C6.93425 8.16621 6.86913 8.15262 6.80839 8.12622C6.74764 8.09983 6.69247 8.06114 6.64602 8.01238L0.646022 1.72906C0.552135 1.63074 0.499391 1.49739 0.499391 1.35835C0.499391 1.2193 0.552135 1.08595 0.646022 0.987631C0.739908 0.889311 0.867247 0.834075 1.00002 0.834075C1.1328 0.834075 1.26014 0.889311 1.35402 0.987631L7.00002 6.90128L12.646 0.987631C12.6925 0.938869 12.7476 0.900182 12.8084 0.873785C12.8691 0.847388 12.9343 0.833801 13 0.833801C13.0658 0.833801 13.1309 0.847388 13.1917 0.873785C13.2524 0.900182 13.3076 0.938869 13.354 0.987631Z",
  fill: "#23335B"
});

var SvgSelect = function SvgSelect(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 9,
    viewBox: "0 0 14 9",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSelect, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/select.58f93e50.svg";
export { ForwardRef as ReactComponent };